import { useCallback } from 'react';
import {
  selectAuthenticationStatus,
  useDispatch,
  useSelector,
} from '@betty/toolkit/state';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { openDeposit } from '@betty/wallet/state';
import { Promotion } from '../state/promos/promos.types';

const usePromoClick = (promo: Promotion) => {
  const dispatch = useDispatch();
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const authStatus = useSelector(selectAuthenticationStatus);

  const onClick = useCallback(() => {
    if (authStatus === 'unauthenticated') {
      navigation.navigate('RegistrationScreen');
    } else if ('contentType' in promo && promo.contentType === 'Referrer') {
      navigation.navigate('PromoDetails', {
        id: promo.slug,
      });
    } else if (promo.cta?.type === 'LaunchDeposit') {
      dispatch(openDeposit());
    } else if (promo.cta?.type === 'LaunchGame' && promo.cta?.gameId) {
      navigation.navigate('GameplayScreen', { id: promo.cta?.gameId });
    } else if (promo.cta?.type === 'NavigationLobby') {
      navigation.navigate('MainTabNavigator', { screen: 'Games' });
    } else if (promo.cta?.type === 'NavigationPromotions') {
      if (promo.promoType === 'InPeriod') {
        navigation.navigate('Quests');
      } else {
        navigation.navigate('Promos');
      }
    } else if (promo.cta?.type === 'NavigationRegister') {
      navigation.navigate('RegistrationScreen');
    } else if (promo.cta?.type === 'NavigationRewards') {
      navigation.navigate('Rewards');
    } else if (promo.cta?.type === 'NavigationReferral') {
      navigation.navigate('Account');
    } else if (promo.promotionId) {
      if (promo.promoType === 'InPeriod') {
        navigation.navigate('QuestDetails', {
          path: `/quests/${promo.promotionId}`,
        });
      } else {
        navigation.navigate('PromoDetails', {
          id: promo.promotionId,
        });
      }
    }
  }, [promo, dispatch, navigation, authStatus]);

  return onClick;
};

export default usePromoClick;
